import { render, staticRenderFns } from "./ExportMenu.vue?vue&type=template&id=36d1171a&scoped=true&"
import script from "./ExportMenu.vue?vue&type=script&lang=ts&"
export * from "./ExportMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ExportMenu.vue?vue&type=style&index=0&id=36d1171a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d1171a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('36d1171a', component.options)
    } else {
      api.reload('36d1171a', component.options)
    }
    module.hot.accept("./ExportMenu.vue?vue&type=template&id=36d1171a&scoped=true&", function () {
      api.rerender('36d1171a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Dashboard/ExportMenu.vue"
export default component.exports